export const ComponentMapping = {
  externalSharedService: ['externalSharedService'],
};
